import { combineReducers } from "redux"
import {
  progressReducer,
  userReducer,
  sectionLengthReducer,
  sectionReducer,
  ageReducer,
  interstitialReducer,
  tokenReducer,
  questionIdReducer,
  responseCompleteReducer,
  resultsResponseCompleteReducer,
  dynamicSectionLengthReducer,
  directionReducer,
  globalUnmountReducer,
  revealProgressReducer,
  updateQuizAnswersReducer,
  productRecoReducer,
  setIsFinasterideMinoxidilReducer,
  setIsNoHairHistoryReducer,
  setIsMhmdReducer,
  setMhmdStateReducer,
  setMhmdOptedReducer,
  setHeaderVariantReducer,
  locationReducer,
} from "../reducers"

export const rootReducer = combineReducers({
  progressReducer: progressReducer,
  userReducer: userReducer,
  sectionLengthReducer: sectionLengthReducer,
  sectionReducer: sectionReducer,
  ageReducer: ageReducer,
  interstitialReducer: interstitialReducer,
  tokenReducer: tokenReducer,
  questionIdReducer: questionIdReducer,
  responseCompleteReducer: responseCompleteReducer,
  resultsResponseCompleteReducer: resultsResponseCompleteReducer,
  dynamicSectionLengthReducer: dynamicSectionLengthReducer,
  directionReducer: directionReducer,
  globalUnmountReducer: globalUnmountReducer,
  revealProgressReducer: revealProgressReducer,
  updateQuizAnswersReducer: updateQuizAnswersReducer,
  productRecoReducer: productRecoReducer,
  setIsFinasterideMinoxidilReducer: setIsFinasterideMinoxidilReducer,
  setIsNoHairHistoryReducer: setIsNoHairHistoryReducer,
  setIsMhmdReducer: setIsMhmdReducer,
  setMhmdStateReducer: setMhmdStateReducer,
  setMhmdOptedReducer: setMhmdOptedReducer,
  setHeaderVariantReducer: setHeaderVariantReducer,
  locationReducer: locationReducer,
})
